import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/data/services";
import { pillars } from "@/data/content";
import { Reveal } from "@/components/site/motion";
import { SectionHeading } from "@/components/site/Blocks";

export const Services = () => {
  const [active, setActive] = useState(0);
  return (
    <section className="section-lux bg-ivory-100" data-testid="home-services">
      <div className="container-lux grid gap-20 lg:grid-cols-[0.9fr_1.1fr] lg:gap-28">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <SectionHeading eyebrow="Advisory Services" lines={["Seven disciplines,", "one standard."]} intro="From a single visitor visa to a family's second citizenship, every mandate receives senior attention and meticulous preparation." />
          <div className="relative mt-16 hidden aspect-[4/5] overflow-hidden lg:block">
            {services.map((s, i) => (
              <img key={s.slug} src={s.image} alt="" loading="lazy" className={`absolute inset-0 h-full w-full object-cover transition-all duration-[1.1s] ease-[cubic-bezier(.2,.7,.2,1)] ${i === active ? "scale-100 opacity-100" : "scale-110 opacity-0"}`} />
            ))}
            <div className="absolute inset-0 bg-navy/10" />
          </div>
        </div>
        <ul className="border-t border-navy/10">
          {services.map((s, i) => (
            <li key={s.slug} onMouseEnter={() => setActive(i)}>
              <Reveal delay={i * 0.05}>
                <Link to={`/services/${s.slug}`} data-testid={`service-tile-${s.slug}`} className="group grid grid-cols-[auto_1fr_auto] items-start gap-6 border-b border-navy/10 py-10 md:gap-10 md:py-12">
                  <span className="pt-4 font-sans text-[11px] font-semibold tracking-[0.25em] text-gold-deep">0{i + 1}</span>
                  <div>
                    <h3 className="font-serif text-4xl font-light text-navy transition-transform duration-700 group-hover:translate-x-3 md:text-[3.25rem] md:leading-none">{s.name}</h3>
                    <p className="mt-5 max-w-md text-[16px] font-light leading-relaxed text-charcoal-soft">{s.short}</p>
                  </div>
                  <ArrowUpRight className="mt-2 h-6 w-6 text-navy/40 transition-all duration-500 group-hover:rotate-45 group-hover:text-gold-deep" />
                </Link>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export const WhyImmistop = () => (
  <section className="section-lux grain relative overflow-hidden bg-navy text-ivory" data-testid="home-why">
    <div className="container-lux relative z-10 grid gap-20 lg:grid-cols-[1fr_1.1fr] lg:gap-28">
      <div className="lg:sticky lg:top-32 lg:self-start">
        <SectionHeading light eyebrow="Why Immistop" lines={["Private banking", "discipline.", <em key="c" className="italic text-gold">Concierge care.</em>]} />
        <Reveal delay={0.2}>
          <div className="relative mt-16 aspect-[4/5] max-w-md overflow-hidden">
            <img src="/img/exec-2.jpg" alt="Senior adviser in a private office" loading="lazy" className="h-full w-full object-cover" />
          </div>
        </Reveal>
      </div>
      <ol className="self-end border-t border-gold/20">
        {pillars.map((p, i) => (
          <Reveal as="li" key={p.title} delay={i * 0.08} className="group grid grid-cols-[3rem_1fr] gap-6 border-b border-gold/20 py-10 md:grid-cols-[4rem_1fr] md:py-12">
            <span className="pt-3 font-sans text-[11px] font-semibold tracking-[0.25em] text-gold">0{i + 1}</span>
            <div data-testid={`why-pillar-${i}`}>
              <h3 className="font-serif text-4xl font-light transition-colors duration-700 group-hover:text-gold md:text-5xl">{p.title}</h3>
              <p className="mt-5 max-w-lg text-[16px] font-light leading-relaxed text-ivory/75">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
